// frontend/src/components/pages/SignUpPage.js
import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function SignupPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    phone_number: '',
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/signup`,
        formData,
        { headers: { 'Content-Type': 'application/json' } }
      );
      alert('회원가입 완료! 로그인 페이지로 이동합니다.');
      navigate('/login');
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      // HTTP 상태코드와 detail 메시지에 따라 alert 띄우기
      if (status === 400) {
        alert(`${detail}`);
      } else {
        alert(
          `회원가입에 실패했습니다. 다시 시도해 주세요.\nDetail: ${detail}`
        );
      }
      console.error(err);
    }
  };

  return (
    <div className="max-w-[400px] mx-auto my-8">
      <h2 className="mb-4 text-2xl font-semibold text-neutral-900">회원가입</h2>

      {error && (
        <p className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </p>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="mb-1 block text-sm font-medium text-neutral-700">
            아이디
          </label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            className="block w-full rounded-lg border border-neutral-300 px-3 py-2
                     text-neutral-900 placeholder-neutral-400
                     focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
            placeholder="아이디"
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-neutral-700">
            이메일
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="block w-full rounded-lg border border-neutral-300 px-3 py-2
                     text-neutral-900 placeholder-neutral-400
                     focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
            placeholder="email@example.com"
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-neutral-700">
            비밀번호
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            className="block w-full rounded-lg border border-neutral-300 px-3 py-2
                     text-neutral-900 placeholder-neutral-400
                     focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
            placeholder="비밀번호"
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium text-neutral-700">
            전화번호
          </label>
          <input
            type="tel"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            className="block w-full rounded-lg border border-neutral-300 px-3 py-2
                     text-neutral-900 placeholder-neutral-400
                     focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"
            placeholder="010-1234-5678"
          />
        </div>

        <button
          type="submit"
          className="inline-flex items-center justify-center rounded-lg
                   bg-sky-600 px-4 py-2 text-white font-medium
                   hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
        >
          회원가입
        </button>
      </form>
    </div>
  );
}
